// Shared WhatsApp deep-link used by every primary CTA on the site.
export const WA_URL =
  "https://wa.me/918130244477?text=Hi%20Atlas%2C%20I%27d%20like%20to%20partner%20with%20you";

// Floating "Chat with Atlas" widget uses a softer opener.
export const WA_URL_FAB =
  "https://wa.me/918130244477?text=Hi%20Atlas%20team%2C%20I%20want%20to%20launch%20my%20brand%20in%20Australia%20and%20New%20Zealand.%20Can%20someone%20guide%20me%3F";
